import dj from "dayjs"

let weekOfYear = require("dayjs/plugin/weekOfYear")
dj.extend(weekOfYear)

const weekDay = ["日", "一", "二", "三", "四", "五", "六"]

export function resolveDueDate(dueDate, taskStatus, completeAt) {
  if (!dueDate) return {}
  let today = dj().format("YYYY-MM-DD")
  dueDate = dj(dueDate).format("YYYY-MM-DD")
  if (dueDate == "Invalid Date") return {}
  let subDays = dj(dueDate).diff(dj(today), "day")
  let currentWeek = dj().week()
  let dueDateWeek = dj(dueDate).week()
  let dueDateStr = "",
    dueDateColor = ""
  if (taskStatus == "已完成" || subDays > 7) {
    dueDateStr = dueDate
    dueDateColor = "#606266"
  } else if (subDays <= 7 && subDays >= 1) {
    if (subDays == 1) dueDateStr = "明天"
    else if (subDays == 2) dueDateStr = "后天"
    else {
      if (currentWeek == dueDateWeek) dueDateStr = "本周" + weekDay[dj(dueDate).format("d")]
      else dueDateStr = "下周" + weekDay[dj(dueDate).format("d")]
    }
    dueDateColor = "#1989FA"
  } else if (subDays == 0) {
    dueDateStr = "今天"
    dueDateColor = "#FFA150"
  } else if (subDays < 0) {
    let absSubDays = Math.abs(subDays)
    if (absSubDays <= 7) {
      if (absSubDays == 1) dueDateStr = "昨天"
      else if (absSubDays == 2) dueDateStr = "前天"
      else {
        if (currentWeek == dueDateWeek) dueDateStr = "本周" + weekDay[dj(dueDate).format("d")]
        else dueDateStr = "上周" + weekDay[dj(dueDate).format("d")]
      }
    } else dueDateStr = dueDate
    dueDateColor = "#FF7373"
  }
  // 逾期列表要显示逾期天数
  let timeoutDay
  if (dueDate) {
    if (taskStatus === "待处理") {
      timeoutDay = dj(today).diff(dj(dueDate), "day")
    } else {
      timeoutDay = dj(completeAt).diff(dj(dueDate), "day")
    }
  }
  return { dueDateStr, dueDateColor, timeoutDay }
}

export function translateTaskList(taskList) {
  if (!taskList?.length) return taskList
  return taskList.map(task => {
    Object.assign(task, resolveDueDate(task.dueDate, task.status, task.completeAt))
    translateTaskList(task.children)
    return task
  })
}

export function changeTaskHeight(taskList, height) {
  if (!taskList?.length || height <= 0) return []
  taskList.forEach(task => {
    if (height === 1) {
      task.children = []
    } else {
      changeTaskHeight(task.children, height - 1)
    }
  })
}

export const permissionList = [
  { name: "编辑", value: "UPDATE" },
  { name: "完成", value: "COMPLETE" },
  { name: "重启", value: "REDO" },
  { name: "删除", value: "DELETE" },
  { name: "更改参与人", value: "CHANGE_PARTICIPANT" },
  { name: "更改负责人", value: "CHANGE_ASSIGNEE" },
  { name: "标记/取消里程碑", value: "MILESTONE" },
  { name: "标记/取消风险", value: "RISK" },
  { name: "移动分组", value: "CHANGE_GROUP" },
  { name: "设置前置任务", value: "PREV_TASK" },
  { name: "设置隐私/公开", value: "PRIVATE" },

  // 字段权限
  { name: "任务标题", value: "UPDATE_NAME", isField: true },
  { name: "负责人", value: "UPDATE_ASSIGNEE", isField: true },
  { name: "开始时间", value: "UPDATE_START_AT", isField: true },
  { name: "截止时间", value: "UPDATE_DUE_DATE", isField: true },
  { name: "父任务", value: "UPDATE_PARENT_ID", isField: true },
  { name: "任务优先级", value: "UPDATE_PRIORITY", isField: true },
  { name: "任务备注", value: "UPDATE_DESCRIPTION", isField: true },
  { name: "任务附件", value: "UPDATE_ATTACHMENT", isField: true },
  { name: "子任务", value: "UPDATE_SUB_TASK", isField: true },
  { name: "负责角色", value: "UPDATE_ASSIGNEE_ROLE", isField: true }
]

export const roleList = [
  { name: "任务负责人", value: "ASSIGNEE" },
  { name: "任务创建人", value: "CREATOR" },
  { name: "任务参与者", value: "PARTICIPANT" }
]

export const permissionMap = {
  UPDATE: 1, // 更新任务
  COMPLETE: 1 << 1, // 完成任务
  REDO: 1 << 2, // 重启任务
  DELETE: 1 << 3, // 删除任务
  CHANGE_ASSIGNEE: 1 << 4, // 修改负责人
  CHANGE_PARTICIPANT: 1 << 5, // 修改参与人
  MILESTONE: 1 << 6, // 标记为里程碑/取消里程碑
  CHANGE_GROUP: 1 << 7, // 移动分组
  PREV_TASK: 1 << 8, // 前置任务
  PRIVATE: 1 << 9, // 私密公开
  RISK: 1 << 10, // 标记为风险/取消风险

  // 字段权限 0xFFFF0000
  UPDATE_NAME: 1 << 16, // 初始为1<<16是为了方便16进制计算
  UPDATE_ASSIGNEE: 1 << 17,
  UPDATE_START_AT: 1 << 18,
  UPDATE_DUE_DATE: 1 << 19,
  UPDATE_PARENT_ID: 1 << 20,
  UPDATE_PRIORITY: 1 << 21,
  UPDATE_DESCRIPTION: 1 << 22,
  UPDATE_ATTACHMENT: 1 << 23,
  UPDATE_SUB_TASK: 1 << 24,
  UPDATE_ASSIGNEE_ROLE: 1 << 25
}

export function checkPermission(rolePri, targetPri) {
  if ((rolePri & permissionMap[targetPri]) == permissionMap[targetPri]) return true
  return false
}

export function getPrisTableData(privileges) {
  let tableData = []
  let emptyRow = {
    name: "",
    ASSIGNEE: false,
    CREATOR: false,
    PARTICIPANT: false
  }
  for (let permission of permissionList) {
    if (permission.isField) continue
    let data = Object.assign({}, emptyRow, { name: permission.name })
    for (let role of roleList) {
      if (checkPermission(privileges[role.value], permission.value)) data[role.value] = true
    }
    tableData.push(data)
  }
  return tableData
}

export function transPrisTableData(tableData) {
  return tableData.reduce((acc, row, index) => {
    for (let key in row) {
      if (key == "name") continue
      if (acc[key] === undefined) acc[key] = 0
      if (row[key]) acc[key] = acc[key] | permissionMap[permissionList[index].value]
    }
    return acc
  }, {})
}

export function transFieldsPri(fields) {
  return fields.reduce((acc, cur) => {
    return cur.checked ? acc | permissionMap[cur.pri] : acc
  }, 0)
}

export function transUserPri(userPri, isAdmin) {
  let userPris = {}
  for (let role in userPri) {
    userPris[role] = permissionList.reduce((acc, permission) => {
      if (isAdmin || checkPermission(userPri[role], permission.value)) acc[permission.value] = true
      else acc[permission.value] = false
      return acc
    }, {})
  }
  return userPris
}

export function getTaskLevel(children) {
  if (children?.length > 0) {
    let max = 0
    children.forEach(child => {
      max = Math.max(getTaskLevel(child.children), max)
    })
    return max + 1
  }
  return 1
}

export function getChildrenIds(task, idList) {
  if (task.children?.length > 0) {
    task.children.forEach(child => {
      idList.push(child.id)
      getChildrenIds(child, idList)
    })
  }
}

export function removeTasks(list, tasks) {
  if (list?.length > 0) {
    list = list.filter(task => {
      return !tasks.includes(task.id)
    })
    list.forEach(task => {
      if (task.children?.length > 0) {
        task.children = removeTasks(task.children, tasks)
      }
    })
  }
  return list
}

function getSortMap__local() {
  let saveSort = localStorage.getItem("taskSortType")
  try {
    saveSort = saveSort ? JSON.parse(saveSort) : {}
  } catch {
    saveSort = {}
  }
  return saveSort
}

function setSortMap__local(map) {
  map = map || {}
  return localStorage.setItem("taskSortType", JSON.stringify(map))
}

export function setTaskSortType(projectId, sort) {
  let sortMap = getSortMap__local()
  sortMap[projectId] = sort
  setSortMap__local(sortMap)
}

export function getTaskSortType(projectId) {
  let sortMap = getSortMap__local()
  return sortMap[projectId] || { key: null, type: null }
}

// 获取所有任务中截止日期最晚的任务
function getLatestTasks(tasks) {
  let taskList = tasks.reduce((acc, task) => {
    if (!task.startAt || !task.dueDate) return acc
    acc.push({ id: task.id, startAt: task.startAt, dueDate: task.dueDate })
    return acc
  }, [])
  taskList.sort((taskA, taskB) => {
    if (taskA.dueDate > taskB.dueDate) return 1
    else if (taskA.dueDate == taskB.dueDate) return 0
    else return -1
  })
  let latestTasks = []
  for (let i = taskList.length - 1; i >= 0; i--) {
    if (latestTasks.length === 0) latestTasks.push(taskList[i])
    else {
      if (taskList[i].dueDate == latestTasks[0].dueDate) latestTasks.push(taskList[i])
      else break
    }
  }
  return latestTasks
}

// 获取任务甘特图的关键路径
export function getCriticalPath(tasks, links) {
  let latestTasks = getLatestTasks(tasks)
  let linkMap = links.reduce((acc, cur) => ((acc[cur.target] = cur), acc), {})
  let taskMap = tasks.reduce((acc, cur) => ((acc[cur.id] = cur), acc), {})
  // 获取截止日期最晚的任务的路径信息
  let paths = []
  for (let task of latestTasks) {
    let path = { tasks: [task.id], links: [], startAt: task.startAt }
    let link = linkMap[task.id]
    while (link) {
      path.links.push(link.id)
      path.tasks.push(link.source)
      if (taskMap[link.source].startAt < path.startAt) path.startAt = taskMap[link.source].startAt
      link = linkMap[link.source]
    }
    paths.push(path)
  }
  // 获取开始时间最早的路径
  paths.sort((pathA, pathB) => {
    if (pathA.startAt > pathB.startAt) return 1
    else if (pathA.startAt == pathB.startAt) return 0
    else return -1
  })
  let earliestPath = []
  for (let i = 0; i < paths.length; i++) {
    if (earliestPath.length === 0) earliestPath.push(paths[i])
    else {
      if (paths[i].startAt == earliestPath[0].startAt) earliestPath.push(paths[i])
      else break
    }
  }
  // 获取关键路径里的taskId、linkId
  let criticalPath = { tasks: [], links: [] }
  earliestPath.forEach(path => {
    criticalPath.tasks = criticalPath.tasks.concat(path.tasks)
    criticalPath.links = criticalPath.links.concat(path.links)
  })
  criticalPath.tasks = [...new Set(criticalPath.tasks)]
  criticalPath.links = [...new Set(criticalPath.links)]
  return criticalPath
}
